export default "__VITE_ASSET__ca614a42__"